module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("市场管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("活动列表")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "活动名称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入活动名称"
    },
    model: {
      value: (_vm.queryParams.name),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "name", $$v)
      },
      expression: "queryParams.name"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "活动分类"
    }
  }, [_c('Col', [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParams.activityType),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "activityType", $$v)
      },
      expression: "queryParams.activityType"
    }
  }, _vm._l((_vm.$constant.activityType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 40,
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParams.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "status", $$v)
      },
      expression: "queryParams.status"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "0"
    }
  }, [_vm._v("禁用")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "justify": "end",
      "type": "flex"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading
    },
    on: {
      "click": _vm.toShowAddActivityModal
    }
  }, [_vm._v("新建活动")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/activity/page",
      "params": _vm.queryParams,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('CreateActivityModal', {
    attrs: {
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    },
    model: {
      value: (_vm.showAddActivityModal),
      callback: function($$v) {
        _vm.showAddActivityModal = $$v
      },
      expression: "showAddActivityModal"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑活动"
    },
    model: {
      value: (_vm.showUpdateActivityModal),
      callback: function($$v) {
        _vm.showUpdateActivityModal = $$v
      },
      expression: "showUpdateActivityModal"
    }
  }, [_c('Form', {
    ref: "updateActivityForm",
    staticClass: "form",
    attrs: {
      "rules": _vm.activityRules,
      "model": _vm.updateActivityParams
    }
  }, [_c('Row', [_c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "海报名称：",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入活动名称用于列表展示"
    },
    model: {
      value: (_vm.updateActivityParams.name),
      callback: function($$v) {
        _vm.$set(_vm.updateActivityParams, "name", $$v)
      },
      expression: "updateActivityParams.name"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动分类：",
      "prop": "activityType"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.updateActivityParams.activityType),
      callback: function($$v) {
        _vm.$set(_vm.updateActivityParams, "activityType", $$v)
      },
      expression: "updateActivityParams.activityType"
    }
  }, _vm._l((_vm.$constant.activityType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动时间：",
      "prop": "activityTime"
    }
  }, [_c('DatePicker', {
    attrs: {
      "value": _vm.defaultTime,
      "format": "yyyy-MM-dd",
      "type": "daterange",
      "placement": "bottom-start",
      "placeholder": "选择起始时间"
    },
    on: {
      "on-change": _vm.timeDateChange
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动标识：",
      "prop": "tag"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入活动标识"
    },
    model: {
      value: (_vm.updateActivityParams.tag),
      callback: function($$v) {
        _vm.$set(_vm.updateActivityParams, "tag", $$v)
      },
      expression: "updateActivityParams.tag"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动状态：",
      "prop": "status"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.updateActivityParams.status),
      callback: function($$v) {
        _vm.$set(_vm.updateActivityParams, "status", $$v)
      },
      expression: "updateActivityParams.status"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "yes"
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "no"
    }
  }, [_vm._v("禁用")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动说明："
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      },
      "placeholder": "请输入活动描述"
    },
    model: {
      value: (_vm.updateActivityParams.description),
      callback: function($$v) {
        _vm.$set(_vm.updateActivityParams, "description", $$v)
      },
      expression: "updateActivityParams.description"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showUpdateActivityModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAddActivity
    },
    on: {
      "click": _vm.updateActivity
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27985fcd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/market/ActivityList.vue
// module id = 1708
// module chunks = 8